import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../HTH";
import {gsap} from "gsap";
import {HTHGameConfig} from "../HTHGameConfig";
import {HTHSymbol} from "../symbols/HTHSymbol";
import {HTHXNudgeSymbol} from "../symbols/HTHXNudgeSymbol";
import {HTHSafeSymbol} from "../symbols/HTHSafeSymbol";
import {HTHEnhancerSymbol} from "../symbols/HTHEnhancerSymbol";
import {HTHSound} from "../sound/HTHSound";

export class HTHXNudgePresentation implements SimplePresentation {

    constructor() {
    }

    shouldRun(): boolean {
        return HTH.model.isXNudgePresent && !HTH.model.isGodModeMaxWin;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                HTH.screenInteractive.setInteractiveState(false);
                controller.setSkipCallback();
                controller.finish()
            }
        });
        if (HTH.model.gameData?.betWayWins.length === 0) {
            HTH.screenInteractive.setInteractiveState(true);
            if (HTHGameConfig.isSkipped[0] && !HTHGameConfig.isSkipped[1]) {
               // console.log("already at 1st skip xnudgepresentation");
                tl.timeScale(2);
            } else if (HTHGameConfig.isSkipped[1]) {
               // console.log("already at 2nd skip xnudgepresentation");
                tl.timeScale(4);
                HTH.screenInteractive.setInteractiveState(false);
            }
        }

        HTH.screenInteractive.clickArea.on('pointerdown', () => {
            if (!HTHGameConfig.isSkipped[0] && !HTHGameConfig.isSkipped[1]) {
             //   console.log("1st skip xnudgepresentation");
                HTHGameConfig.isSkipped[0] = true;
                tl.timeScale(2);
            } else if (HTHGameConfig.isSkipped[0] && !HTHGameConfig.isSkipped[1]) {
              //  console.log("2nd skip xnudgepresentation");
                HTHGameConfig.isSkipped[1] = true;
                tl.timeScale(4);
                HTH.screenInteractive.setInteractiveState(false);
            }
        });

        if (HTH.model.gameData?.betWayWins.length > 0) {
            controller.setSkipCallback(() => { //keeping in if condition because it was getting click before interactive screen
                tl.totalProgress(1);
                if (HTHSound.soundPlayer.fetchSoundPlayer(HTHSound.XN_BIKER)?.isPlaying) {
                    HTHSound.stopSound(HTHSound.XN_BIKER);
                }
                if (HTHSound.soundPlayer.fetchSoundPlayer(HTHSound.XN_NUDGE)?.isPlaying) {
                    HTHSound.stopSound(HTHSound.XN_NUDGE);
                }
                HTHSound.playTrack(HTHSound.XN_ABORT);
            });
        }


        tl.add(this.nudge());
    }

    public nudge(isRestore: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        let toPlayNoWinXNSound: boolean = true;

        HTH.model.xNudgePositionPerReel.forEach((arr, index) => {
            if (arr.length > 0) {
                const xNSym: HTHSymbol = HTH.reelArea.getSymbol(arr);
                const indiXNTl: gsap.core.Timeline = gsap.timeline();
                let isWinSymbol: boolean = false;
                if (!HTH.reelArea.allReels[xNSym.reelId].reelView.isStacked) {
                    const nudgeTl: gsap.core.Timeline = gsap.timeline();

                    if (xNSym.symName === "SA" || xNSym.symName === "EB") {
                        isWinSymbol = (<HTHXNudgeSymbol>((<HTHSafeSymbol | HTHEnhancerSymbol>xNSym).revealedSymbol!)).isPartOfWin;
                    } else {
                        isWinSymbol = (<HTHXNudgeSymbol>xNSym).isPartOfWin
                    }
                    if (isWinSymbol) {
                        toPlayNoWinXNSound = false;
                    }
                    nudgeTl.add(() => {
                        // if (xNSym.symName !== "EB") {
                        if (xNSym.symName === "SA" || xNSym.symName === "EB") {
                            HTH.reelArea.allReels[xNSym.reelId].reelView.moveSymUpLayer((<HTHSafeSymbol | HTHEnhancerSymbol>xNSym).revealedSymbol!);
                            (<HTHXNudgeSymbol>((<HTHSafeSymbol | HTHEnhancerSymbol>xNSym).revealedSymbol!)).moveMultiplierLayerUp();
                        } else {
                            HTH.reelArea.allReels[xNSym.reelId].reelView.moveSymUpLayer(xNSym);
                            (<HTHXNudgeSymbol>xNSym).moveMultiplierLayerUp();
                        }
                        // }
                    })
                    nudgeTl.to(this, {duration: 0.05});
                    nudgeTl.addLabel("animStart");

                    nudgeTl.add(this.runNudgeAnim(xNSym, isRestore));
                    if (toPlayNoWinXNSound) {
                        nudgeTl.add(() => {
                            HTHSound.playTrack(HTHSound.XN_NOWIN);
                        }, "<")
                        toPlayNoWinXNSound = false;
                    }

                    const myTl: gsap.core.Timeline = gsap.timeline();
                    let durr: number = 0;
                    for (let i = xNSym.id - 1; i >= 0; i--) {
                        const sym: HTHSymbol = HTH.reelArea.getSymbol([arr[0], i]);
                        myTl.add(this.nudgeAnim(xNSym, sym), durr);
                        durr = isWinSymbol ? durr + 0.25 : durr + 0.166;
                    }
                    for (let i = xNSym.id + 1; i < 4; i++) {
                        const sym: HTHSymbol = HTH.reelArea.getSymbol([arr[0], i]);
                        myTl.add(this.nudgeAnim(xNSym, sym), durr);
                        durr = isWinSymbol ? durr + 0.25 : durr + 0.166;
                    }

                    nudgeTl.add(myTl, "animStart");

                    for (let i: number = 0; i < 4; i++) {
                        const sym: HTHSymbol = HTH.reelArea.getSymbol([arr[0], i]);
                        nudgeTl.add(() => {
                            if (sym.symName !== "SA" && sym.symName !== "EB") {
                                if (sym.name === "XN" && i === arr[1]) {

                                } else {
                                    sym.destroyForNudge();
                                }
                            }
                        });
                    }
                    if(isWinSymbol){
                        indiXNTl.add(nudgeTl.timeScale(0.8));
                    }
                    else{
                        indiXNTl.add(nudgeTl.totalDuration(0.1));
                    }

                }
                tl.add(indiXNTl, !isWinSymbol ? "<" : ">");
            }
        })
        tl.addLabel("playBiker");
        tl.to(this,{duration:0.05},"playBiker");
        let isFirstBikerNudge = true;
        HTH.model.xNudgePositionPerReel.forEach((arr, index) => {
            if (arr.length > 0) {
                const xNSym: HTHSymbol = HTH.reelArea.getSymbol(arr);
                const myTl: gsap.core.Timeline = gsap.timeline();
                let isWinSymbol: boolean = false;
                if (!HTH.reelArea.allReels[xNSym.reelId].reelView.isStacked) {
                    const nudgeXNTl: gsap.core.Timeline = gsap.timeline();
                    if (xNSym.symName === "SA" || xNSym.symName === "EB") {
                        isWinSymbol = (<HTHXNudgeSymbol>((<HTHSafeSymbol | HTHEnhancerSymbol>xNSym).revealedSymbol!)).isPartOfWin;
                    } else {
                        isWinSymbol = (<HTHXNudgeSymbol>xNSym).isPartOfWin
                    }
                    if (isWinSymbol) {
                        nudgeXNTl.add(this.runBikerAnim(xNSym));
                        if (isFirstBikerNudge) {
                            nudgeXNTl.add(() => {
                                HTHSound.playTrack(HTHSound.XN_BIKER);
                            }, "<")
                            isFirstBikerNudge = false;
                        }
                    }
                    myTl.add(nudgeXNTl);
                }
                tl.add(myTl, "playBiker");
            }
        })

        tl.add(() => {
            HTH.model.xNudgePositionPerReel.forEach(arr => {
                if (arr.length > 0) {
                    const xNSymbol: HTHSymbol = HTH.reelArea.getSymbol(arr);
                    let isEnhancerOpen: boolean = true;
                    const sym: HTHSymbol = HTH.reelArea.getSymbol([xNSymbol.reelId, 3]);
                    if (sym.symName === "EB") {
                        if (!(<HTHEnhancerSymbol>sym).isEnhancerOpen) {
                            isEnhancerOpen = false;
                        }
                    }
                    HTH.reelArea.allReels[xNSymbol.reelId].reelView.makeBlankSymbolsOnReel(false, xNSymbol.id);//make. blank symbol
                    if (xNSymbol.name === "SA") {
                        (<HTHXNudgeSymbol>((<HTHSafeSymbol>xNSymbol).revealedSymbol!)).moveMultiplierLayerDown(isEnhancerOpen);
                    } else if (xNSymbol.name === "EB") {
                        (<HTHXNudgeSymbol>((<HTHEnhancerSymbol>xNSymbol).revealedSymbol!)).moveMultiplierLayerDown(isEnhancerOpen);
                    } else {
                        (<HTHXNudgeSymbol>xNSymbol).moveMultiplierLayerDown(isEnhancerOpen);
                    }
                }
            });
        });

        tl.to(this, {duration: 0.05});
        return tl;
    }

    private runNudgeAnim(xNSymbol: HTHSymbol, isRestore: boolean = false): gsap.core.Timeline {
        const animTl: gsap.core.Timeline = gsap.timeline();
        let isEnhancerOpen: boolean = true;

        const sym: HTHSymbol = HTH.reelArea.getSymbol([xNSymbol.reelId, 3]);
        if (sym.symName === "EB") {
            if (!(<HTHEnhancerSymbol>sym).isEnhancerOpen) {
                isEnhancerOpen = false;
            }
        }
        if (xNSymbol.name === "EB") {
            animTl.add((<HTHEnhancerSymbol>xNSymbol).playXNudgeAnim(xNSymbol.id, isEnhancerOpen, isRestore));
        } else if (xNSymbol.name === "SA") {
            animTl.add((<HTHSafeSymbol>xNSymbol).playXNudgeAnim(xNSymbol.id, isEnhancerOpen, isRestore));
        } else {
            animTl.add((<HTHXNudgeSymbol>xNSymbol).playXNudgeAnim(xNSymbol.id, isEnhancerOpen, isRestore));
        }

        return animTl;
    }

    private runBikerAnim(xNSymbol: HTHSymbol): gsap.core.Timeline {
        const animTl: gsap.core.Timeline = gsap.timeline();
        let isEnhancerOpen: boolean = true;

        const sym: HTHSymbol = HTH.reelArea.getSymbol([xNSymbol.reelId, 3]);
        if (sym.symName === "EB") {
            if (!(<HTHEnhancerSymbol>sym).isEnhancerOpen) {
                isEnhancerOpen = false;
            }
        }
        if (xNSymbol.name === "EB") {
            animTl.add((<HTHEnhancerSymbol>xNSymbol).playBikerAnim(xNSymbol.id, isEnhancerOpen));
        } else if (xNSymbol.name === "SA") {
            animTl.add((<HTHSafeSymbol>xNSymbol).playBikerAnim(xNSymbol.id, isEnhancerOpen));
        } else {
            animTl.add((<HTHXNudgeSymbol>xNSymbol).playBikerAnim(xNSymbol.id, isEnhancerOpen));
        }

        return animTl;
    }

    private nudgeAnim(xNSymbol: HTHSymbol, symToNudge: HTHSymbol): gsap.core.Timeline {
        const animTl: gsap.core.Timeline = gsap.timeline();
        if (symToNudge.id !== xNSymbol.id) {
            if (symToNudge.symName === "EB") {
                if ((<HTHEnhancerSymbol>symToNudge).isEnhancerOpen) {
                    animTl.add((<HTHXNudgeSymbol | HTHEnhancerSymbol | HTHSafeSymbol>xNSymbol).revealXNudgeSize(symToNudge.id, (<HTHEnhancerSymbol>symToNudge).revealedSymSize));
                    animTl.add(() => {
                        (<HTHEnhancerSymbol>symToNudge).emptyRevealContainer();
                    }, ">");
                }
            } else if (symToNudge.symName === "SA") {
                animTl.add((<HTHXNudgeSymbol | HTHEnhancerSymbol | HTHSafeSymbol>xNSymbol).revealXNudgeSize(symToNudge.id, (<HTHSafeSymbol>symToNudge).safeSymSize));
                animTl.add(() => {
                    (<HTHSafeSymbol>symToNudge).emptyRevealContainer();
                }, ">");
            } else {
                animTl.add((<HTHXNudgeSymbol | HTHEnhancerSymbol | HTHSafeSymbol>xNSymbol).revealXNudgeSize(symToNudge.id, symToNudge.symSize));
            }
        }
        return animTl;
    }
}